import { Component, OnInit } from '@angular/core';
import { QSNotificationsService } from './../services/notifications.service';

@Component({
  selector: 'prg-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.less']
})
export class QSPushNotificationComponent implements OnInit {

  constructor(
    private _notifications: QSNotificationsService
  ) { }

  ngOnInit() {
    this._notifications.clear();
    this._notifications.setAgentType('push');
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/push-notification/push-notification.component.ts